module.exports = "/_next/static/images/Hero-c4220adc1f0926522ded314e47ddfef8.webp";